import React from 'react'
import { useIntl } from 'react-intl'
import { Icons, SideFlyoutContainer } from '../../../'
import * as T from './MiniCart.types'

const MiniCartWrapper = ({
  hasFlyOut = false,
  data,
  children
}: T.MiniCartWrapperProps) => {
  const { formatMessage } = useIntl()

  if (hasFlyOut) {
    const { productsQuantity, showMiniCart, setShowMiniCart } = data
    return (
      <SideFlyoutContainer
        position='right'
        width='w-screen md:w-[478px]'
        marginBotton='mb-0 border-b-4 border-solid border-black'
        iconHeight='14px'
        titleContent={
          <div className='flex h-full items-center space-x-2'>
            <div>
              {formatMessage({
                id: 'msp.minicart.title',
                defaultMessage: 'Cart'
              })}
            </div>
            <Icons iconName='Basket' color='#000' height='14px' width='14px' />
            {productsQuantity > 0 && <div>{`(${productsQuantity})`}</div>}
          </div>
        }
        className='mb-0 bg-opacity-25'
        isOpen={showMiniCart}
        onOpen={() => {}}
        onClose={() => setShowMiniCart(false)}
      >
        {children}
      </SideFlyoutContainer>
    )
  }

  return <>{children}</>
}

export default MiniCartWrapper
